import React, { createContext, useContext, useState, useEffect } from "react";

const translations = {
  en: {
    nav_home: "Home", nav_packages: "Packages", nav_gallery: "Gallery",
    nav_inquiry: "Wedding Inquiry", nav_track: "Track Booking", nav_contact: "Contact",
    book_now: "Book Now", call_for_price: "Call for Price", view_details: "View Details",
    enquire: "Enquire", customization_extra: "+ Customization charges extra",
    hero_tag: "Ahmedabad's Premium Event Decorators",
    hero_title: "We Turn Moments Into Magic",
    hero_sub: "Light, floral & celebration decor for weddings, birthdays, baby showers and more. Book online with just 10% advance.",
    explore_packages: "Explore Packages", wedding_inquiry: "Wedding Inquiry",
    our_services: "Our Services", services_sub: "Fixed-price packages, booked online in minutes",
    why_us: "Why Metrix", gallery_title: "Our Work", gallery_sub: "A glimpse of celebrations we've styled",
    starting_at: "Starting at", inclusions: "Inclusions",
    select_date: "Select Date", your_details: "Your Details", payment: "Advance Payment",
    step: "Step", check_availability: "Check Availability", date_available: "Date is available!",
    date_unavailable: "Date not available", continue: "Continue", back: "Back",
    full_name: "Full Name", email: "Email", phone: "Phone / WhatsApp", event_address: "Event Address",
    notes: "Notes (optional)", pay_advance: "Pay 10% Advance & Confirm",
    package_price: "Package Price", advance_10: "Advance (10%)", balance_due: "Balance Due",
    booking_summary: "Booking Summary", processing: "Processing...",
    inquiry_title: "Wedding & Custom Inquiry",
    inquiry_sub: "Tell us about your dream event. For custom weddings, flower showers & bespoke setups, our team will craft a tailored quote.",
    event_type: "Event Type", budget: "Approx Budget (optional)", message: "Your Requirements",
    submit_inquiry: "Submit Inquiry", inquiry_success: "Inquiry received! Our team will contact you soon.",
    track_title: "Track Your Booking", booking_number: "Booking Number",
    contact_verify: "Registered Email or Phone", track_btn: "Track",
    status: "Status", event_date: "Event Date", cancel_booking: "Cancel Booking",
    refund_note: "On cancellation, 75% of the paid advance is refundable as per policy.",
    contact_title: "Get In Touch", address: "Address", whatsapp_us: "WhatsApp Us",
    footer_tag: "Premium event decoration & management in Ahmedabad.",
    service_area: "Service available in Ahmedabad & Gandhinagar, Gujarat only.",
    lang_toggle: "ગુજરાતી",
    status_pending_payment: "Pending Payment", status_booked: "Booked", status_confirmed: "Confirmed",
    status_in_progress: "In Progress", status_completed: "Completed", status_cancelled: "Cancelled",
  },
  gu: {
    nav_home: "હોમ", nav_packages: "પેકેજ", nav_gallery: "ગેલેરી",
    nav_inquiry: "લગ્ન પૂછપરછ", nav_track: "બુકિંગ ટ્રૅક", nav_contact: "સંપર્ક",
    book_now: "બુક કરો", call_for_price: "કિંમત માટે કૉલ કરો", view_details: "વિગત જુઓ",
    enquire: "પૂછપરછ", customization_extra: "+ કસ્ટમાઇઝેશન ચાર્જ અલગ",
    hero_tag: "અમદાવાદના પ્રીમિયમ ઇવેન્ટ ડેકોરેટર",
    hero_title: "અમે ક્ષણોને જાદુમાં ફેરવીએ છીએ",
    hero_sub: "લગ્ન, બર્થડે, બેબી શાવર અને વધુ માટે લાઇટ, ફ્લોરલ અને ઉજવણી ડેકોર. માત્ર ૧૦% એડવાન્સમાં ઓનલાઇન બુક કરો.",
    explore_packages: "પેકેજ જુઓ", wedding_inquiry: "લગ્ન પૂછપરછ",
    our_services: "અમારી સેવાઓ", services_sub: "ફિક્સ-પ્રાઇસ પેકેજ, મિનિટોમાં ઓનલાઇન બુક",
    why_us: "શા માટે Metrix", gallery_title: "અમારું કામ", gallery_sub: "અમે સજાવેલી ઉજવણીઓની ઝલક",
    starting_at: "થી શરૂ", inclusions: "સમાવિષ્ટ",
    select_date: "તારીખ પસંદ કરો", your_details: "તમારી વિગતો", payment: "એડવાન્સ પેમેન્ટ",
    step: "સ્ટેપ", check_availability: "ઉપલબ્ધતા તપાસો", date_available: "તારીખ ઉપલબ્ધ છે!",
    date_unavailable: "તારીખ ઉપલબ્ધ નથી", continue: "આગળ", back: "પાછળ",
    full_name: "પૂરું નામ", email: "ઈમેલ", phone: "ફોન / વોટ્સએપ", event_address: "ઇવેન્ટ સરનામું",
    notes: "નોંધ (વૈકલ્પિક)", pay_advance: "૧૦% એડવાન્સ ભરો અને કન્ફર્મ કરો",
    package_price: "પેકેજ કિંમત", advance_10: "એડવાન્સ (૧૦%)", balance_due: "બાકી રકમ",
    booking_summary: "બુકિંગ સારાંશ", processing: "પ્રોસેસિંગ...",
    inquiry_title: "લગ્ન અને કસ્ટમ પૂછપરછ",
    inquiry_sub: "તમારા સપનાના ઇવેન્ટ વિશે જણાવો. કસ્ટમ લગ્ન, ફ્લાવર શાવર અને ખાસ સેટઅપ માટે અમારી ટીમ ખાસ ક્વોટ બનાવશે.",
    event_type: "ઇવેન્ટ પ્રકાર", budget: "અંદાજિત બજેટ (વૈકલ્પિક)", message: "તમારી જરૂરિયાત",
    submit_inquiry: "પૂછપરછ મોકલો", inquiry_success: "પૂછપરછ મળી! અમારી ટીમ ટૂંક સમયમાં સંપર્ક કરશે.",
    track_title: "તમારું બુકિંગ ટ્રૅક કરો", booking_number: "બુકિંગ નંબર",
    contact_verify: "રજિસ્ટર્ડ ઈમેલ અથવા ફોન", track_btn: "ટ્રૅક",
    status: "સ્થિતિ", event_date: "ઇવેન્ટ તારીખ", cancel_booking: "બુકિંગ રદ કરો",
    refund_note: "રદ કરવા પર, ભરેલા એડવાન્સના ૭૫% પોલિસી મુજબ રિફંડ થશે.",
    contact_title: "સંપર્કમાં રહો", address: "સરનામું", whatsapp_us: "વોટ્સએપ કરો",
    footer_tag: "અમદાવાદમાં પ્રીમિયમ ઇવેન્ટ ડેકોરેશન અને મેનેજમેન્ટ.",
    service_area: "સેવા માત્ર અમદાવાદ અને ગાંધીનગર, ગુજરાતમાં ઉપલબ્ધ છે.",
    lang_toggle: "English",
    status_pending_payment: "પેમેન્ટ બાકી", status_booked: "બુક થયું", status_confirmed: "કન્ફર્મ",
    status_in_progress: "ચાલુ છે", status_completed: "પૂર્ણ", status_cancelled: "રદ",
  },
};

const LangContext = createContext();

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("mx_lang") || "gu");
  useEffect(() => {
    localStorage.setItem("mx_lang", lang);
  }, [lang]);
  const t = (key) => translations[lang][key] || translations.en[key] || key;
  const toggle = () => setLang((l) => (l === "en" ? "gu" : "en"));
  return (
    <LangContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
export const pick = (obj, lang, base) => obj[`${base}_${lang}`] || obj[`${base}_en`] || "";
